import profile from './profile'
import accessAccount from './access-account'
import rekeningBank from './rekening-bank'
import ekspedisi from './ekspedisi'
import pin from './pin'
import paymentSetting from './payment-setting'

export default [
  ...profile, ...accessAccount, ...rekeningBank, ...ekspedisi, ...pin, ...paymentSetting,
]
